import { render } from "./TOC.vue?vue&type=template&id=8c195c22&scoped=true"
import script from "./TOC.vue?vue&type=script&lang=js"
export * from "./TOC.vue?vue&type=script&lang=js"

import "./TOC.vue?vue&type=style&index=0&id=8c195c22&scoped=true&lang=css"

import exportComponent from "/app/tmp/downer/V3/v2025.50.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c195c22"]])

export default __exports__